





















































































import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';
import { OrganisationState, Organisation } from '@/types';
import { Action, Getter, Mutation } from 'vuex-class';
import UserProfileForm from '@/components/UserProfileForm.vue';
import Menu from '@/components/Menu.vue';
import { RouterHelper } from '@/router';
import store from '@/store/store';
import UserService from '@/services/user.service';
import ConfirmButton from '@/components/ConfirmButton.vue';
import Dialog from '@/components/Dialog.vue';
import GenericButton from '@/components/GenericButton.vue';

@Component({
  components: {
    GenericButton,
    Dialog,
    ConfirmButton,
    UserProfileForm,
    Menu,
  },
})
export default class UserMenu extends Vue {
  @Prop() private showUserMenu: any;
  @Prop() private isMobileMenu: any;
  private modalVisible: boolean = false;
  private mobileMenuHidden: boolean = true;
  private showPermissions: boolean = false;
  private showImpersonateMenu: boolean = false;
  private impersonateEmail: string = '';
  private experimentalMode: boolean = false;
  private showAllOrgs: boolean = false;
  @Getter private organisations: any;
  @Getter private login: any;
  @Getter private permissions: any;
  @Getter private isImpersonated!: () => boolean;
  @Getter private experimental!: boolean;
  // TODO: Organisation scoping
  @Getter private activeOrganisationId: any;
  @Getter private activeOrganisation: any;
  @Getter private hasPermission: any;
  @Getter private hasDaizyDebug: any;
  @Getter private showAllOrganisations: any;
  @Action private userLogout: any;
  @Action private userDetailsAsync: any;
  @Mutation private setShowInterface: any;
  @Mutation private setExperimental: any;
  @Mutation private toggleShowAllOrganisations: any;

  private mounted() {
    this.experimentalMode = this.experimental;
    this.showAllOrgs = this.showAllOrganisations;
  }

  @Watch('experimentalMode')
  private onExperimentalModeChanged(val: boolean) {
    if (val !== this.experimental) {
      this.setExperimental(val);
      // RouterHelper.home();
    }
  }


  private permissionsMenuShown(value: boolean) {
    this.showPermissions = value;
  }


  // private toggleMobileMenu() {
  //  this.mobileMenuHidden = !this.mobileMenuHidden;
  // }

  private logout() {
    this.userLogout();
  }

  private userDetails(field: string) {
    if (!this.login || !this.login.details) {
      return '-';
    }
    if (field === 'name') {
      return `${this.login.details.first_name} ${this.login.details.last_name}`;
    }
    if (field === 'email') {
      return `${this.login.details.email}`;
    }
  }

  private async showModal() {
    await this.userDetailsAsync();
    this.modalVisible = true;
  }

  private async closeModal() {
    await this.userDetailsAsync();
    this.modalVisible = false;
  }

  private async toggleImpersonateMenu(show: boolean) {
    this.impersonateEmail = '';
    this.showImpersonateMenu = show;
  }

  private async impersonate() {
    if (!this.impersonateEmail) {
      return;
    }
    const trimmed = encodeURIComponent(this.impersonateEmail.trim());
    const token = await UserService.impersonate(trimmed);

    store.commit('impersonate', { token });
    await store.dispatch('userDetailsAsync');
    await store.dispatch('addOrganisationsAsync');
    await store.dispatch('addAccountsAsync');

    this.showImpersonateMenu = false;
    RouterHelper.home();
  }

  private async stopImpersonate() {
    store.commit('stopImpersonate');
    await store.dispatch('userDetailsAsync');
    await store.dispatch('addOrganisationsAsync');
    await store.dispatch('addAccountsAsync');
    RouterHelper.home();
  }

}
